module.exports = __webpack_public_path__ + "media/images/réception ouverte 24h-24-556e692d84e9b49e8fbc6837e3d4d648.svg";